<template>
  <div class='lt-scene-transport'>
    <transition name='lt-bus-stop'>
      <img
        src="../../assets/transport-1-stop.svg"
        class="lt-scene-transport_stop"
        v-show="transport === 1"
        alt=""
      />
    </transition>


    <transition name='lt-drive-in'>
      <img
        src="../../assets/transport-1.svg"
        class="lt-scene-transport_1"
        v-show="transport === 1"
        alt=""
      />
    </transition>

    <transition name='lt-drive-in'>
      <img
        src="../../assets/transport-2.svg"
        class="lt-scene-transport_2"
        v-show="transport === 2"
        alt=""
      />
    </transition>

    <transition name='lt-drive-in'>
      <img
        src="../../assets/transport-3.svg"
        class="lt-scene-transport_3"
        v-show="transport === 3"
        alt=""
      />
    </transition>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  computed: {
    ...mapFields([
      'scene.status.transport',
    ]),
  },
};
</script>

<style lang='scss'>
$img-base: '../../assets';

$img-width: 434;
$img-height: 267;

.lt-scene-transport {
  position: absolute;
  top: proportionSize(170, $scene-height);
  left: proportionSize(1171, $scene-width);
  width: proportionSize(434, $scene-width);
  height: proportionSize(266, $scene-height);

  background: transparent url("#{$img-base}/transport-bg.svg") no-repeat center center;
  background-size: cover;
  overflow: hidden;
}

.lt-scene-transport_stop {
  position: absolute;
  bottom: 0;
  height: proportionSize(180, $img-height);
  left: proportionSize(24, $img-width);
}

.lt-scene-transport_1,
.lt-scene-transport_2,
.lt-scene-transport_3 {
  position: absolute;
  bottom: 0;
  right: 0;
}

.lt-scene-transport_1 {
  height: proportionSize(123, $img-height);
  bottom: 0;
}

.lt-scene-transport_2 {
  height: proportionSize(95, $img-height);
  bottom: -10px;
}

.lt-scene-transport_3 {
  height: proportionSize(123, $img-height);
  bottom: -16px;
}


.lt-drive-in-enter-active {
  transition: transform .5s linear .3s;
}

.lt-drive-in-leave-active {
  transition: transform .3s linear, opacity .3s linear;
}

.lt-drive-in-enter {
  transform: translateX(100%);
}

.lt-drive-in-leave-to {
  transform: translateX(-60%);
  opacity: 0;
}


.lt-bus-stop-enter, .lt-bus-stop-leave-to {
  transform: translateY(100%);
  opacity: 0.4;
}

.lt-bus-stop-enter-active {
  transition: transform .3s linear .6s, opacity .3s linear .6s;
}

.lt-bus-stop-leave-active {
  transition: transform .6s linear, opacity .6s linear;
}

</style>
